import React from "react";
import 'bootstrap/dist/css/bootstrap.css'
import './procentent.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export function Porcentect(){
    return(
        <div className="centectbody" id="pcon">
            <div className="container-fluid">
              
                <div className="row">
                    <h1 className="contactcon ml-4">CONTACT</h1>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5457.077973241005!2d77.20535310042072!3d10.501806694261655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9d2cfebc7a0b3%3A0x70aca1212364b7ad!2sJallipatti%2C%20Tamil%20Nadu%20642112!5e0!3m2!1sen!2sin!4v1680589172407!5m2!1sen!2sin"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" className="maplive"></iframe>
                    <div className="col-lg-12 centactbottom p-3">
                        <div className="col-lg-12 row">
                        <div className="col-lg-3">
                        <h3 className="centactadd my-5">Address</h3>
                        <h4>3/79 Kamaraj Street,</h4>
                        <h4>Jallipatty,Udumalpet,</h4>
                        <h4>Tiruppur-642112</h4>
                        </div>
                        <div className="col-lg-3">
                            <h3 className="my-5">MY Contact</h3>
                            <Link to='tel:9489692558' className=" non text-light ">Phone:+91 9489692558</Link>
                        </div>
                        <div className="col-lg-6 mt-5"> 
                    <Link to='https://github.com/haridassthangadurai' className="m-5 non contectfontaw" target="_blank">  <FontAwesomeIcon icon={faGithub} /></Link> 
                    <Link to='mailto:www.haridassthangadurai26@gmail.com' className="m-5 non contectfontaw">    <FontAwesomeIcon icon={faEnvelope} /></Link>
                    <Link to='https://www.linkedin.com/in/haridass-thangadurai-438570262/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3B5MjfaSWdS0KawBAmLDJTSA%3D%3D' className="m-5 non contectfontaw" target="_blank">    <FontAwesomeIcon icon={faLinkedin} /></Link>
                    <Link to='tel:9489692558' className="contectfontaw non m-5">    <FontAwesomeIcon icon={faPhone} /></Link>

                             
                        </div>
                        </div>
                    </div>
            

                </div>
            </div>

        </div>
    );
}
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5457.077973241005!2d77.20535310042072!3d10.501806694261655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9d2cfebc7a0b3%3A0x70aca1212364b7ad!2sJallipatti%2C%20Tamil%20Nadu%20642112!5e0!3m2!1sen!2sin!4v1680589172407!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>